import axios from "axios"
import "./Header.scss"
import { useNavigate } from "react-router-dom";


const Header = ({menuToggleHandler}) => {
  const navigate = useNavigate();
  const api = process.env.REACT_APP_API_URL;
  return (
    <header className="admin-header">
      <div className="header-left">
        <button className="menu-btn" onClick={menuToggleHandler} aria-label="Toggle menu">
          <i className="ri-menu-2-fill"></i>
        </button>
        <h1 className="header-title">Admin Dashboard</h1>
      </div>

      <div className="header-right">
        <button style={{cursor:"pointer"}} title="log out"  onClick={async()=>{
          try{
            await axios.post(`${api}/logout/adm`, {}, { withCredentials: true });
          navigate('/admin/login');
          }
          catch(e){
            console.error("Logout failed (no connection):", e);
          }
        }} >
          <i className="ri-logout-box-r-fill" style={{fontSize: "1.5rem"}}></i>
        </button>
      </div>
    </header>
  )
}

export default Header